// // // /*
// // //   ReelsSection.jsx — drop-in replacement for the Our Reels section in Home.jsx

// // //   USAGE in Home.jsx:
// // //     import ReelsSection from "./ReelsSection";
// // //     // Replace the <section className="cc-sec cc-sec-dark"> reels block with:
// // //     <ReelsSection />

// // //   TO ADD YOUR OWN VIDEOS:
// // //     Option A — Local MP4:
// // //       import vid1 from "./videos/reel1.mp4";
// // //       import thumb1 from "./images/reel-thumb1.jpg";
// // //       Then set:  { ..., videoSrc: vid1, img: thumb1 }

// // //     Option B — YouTube:
// // //       Set:  { ..., ytId: "dQw4w9WgXcQ" }
// // //       The thumbnail auto-loads from YouTube.

// // //     Option C — Keep Unsplash thumb only (no video):
// // //       Leave both videoSrc and ytId as null.
// // //       Card will show a "Coming Soon" state.
// // // */

// // // import React, { useState, useEffect, useRef } from "react";

// // // const C = {
// // //   primary:      "#5E0E73",
// // //   primaryLight: "#6E1A85",
// // //   gold:         "#C9A84C",
// // //   goldLight:    "#E8D5A0",
// // //   dark:         "#1A0030",
// // //   dark2:        "#120020",
// // // };

// // // /* ═══════════════════════════════════════════════════════════
// // //    REELS DATA
// // //    - img:       thumbnail shown before play (Unsplash or local import)
// // //    - ytId:      YouTube video ID  (set this OR videoSrc, not both)
// // //    - videoSrc:  local .mp4 path   (import and set here)
// // //    - views:     display string
// // //    - title:     card label
// // //    ═══════════════════════════════════════════════════════════ */
// // // const REELS = [
// // //   {
// // //     views:    "124K",
// // //     title:    "Royal Birthday Setup",
// // //     img:      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=500&q=80",
// // //     ytId:     null,       // e.g. "abc123XYZ"
// // //     videoSrc: null,       // e.g. import vid1 from "./videos/reel1.mp4" → vid1
// // //   },
// // //   {
// // //     views:    "89K",
// // //     title:    "Surprise Proposal",
// // //     img:      "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // //   {
// // //     views:    "203K",
// // //     title:    "Fog Entry Magic",
// // //     img:      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // //   {
// // //     views:    "67K",
// // //     title:    "Anniversary Night",
// // //     img:      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // //   {
// // //     views:    "91K",
// // //     title:    "Floral Decor Setup",
// // //     img:      "https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // //   {
// // //     views:    "45K",
// // //     title:    "Cake Cutting Moment",
// // //     img:      "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // //   {
// // //     views:    "78K",
// // //     title:    "Kids Birthday Party",
// // //     img:      "https://images.unsplash.com/photo-1555244162-803834f70033?w=500&q=80",
// // //     ytId:     null,
// // //     videoSrc: null,
// // //   },
// // // ];

// // // /* ─── Single Reel Card ───────────────────────────────────── */
// // // function ReelCard({ reel, isPlaying, onPlay, onClose }) {
// // //   const videoRef = useRef(null);
// // //   const hasVideo = !!(reel.ytId || reel.videoSrc);

// // //   /* play local video when card becomes active */
// // //   useEffect(() => {
// // //     if (!videoRef.current) return;
// // //     if (isPlaying) {
// // //       videoRef.current.play().catch(() => {});
// // //     } else {
// // //       videoRef.current.pause();
// // //       videoRef.current.currentTime = 0;
// // //     }
// // //   }, [isPlaying]);

// // //   return (
// // //     <div
// // //       className={`rl-card ${isPlaying ? "rl-playing" : ""}`}
// // //       onClick={() => {
// // //         if (isPlaying) onClose();
// // //         else if (hasVideo) onPlay();
// // //       }}
// // //     >
// // //       {/* ── Playing: YouTube embed ── */}
// // //       {isPlaying && reel.ytId && (
// // //         <div className="rl-embed">
// // //           <iframe
// // //             src={`https://www.youtube.com/embed/${reel.ytId}?autoplay=1&rel=0&modestbranding=1`}
// // //             title={reel.title}
// // //             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// // //             allowFullScreen
// // //           />
// // //           <button className="rl-close" onClick={e => { e.stopPropagation(); onClose(); }}>✕</button>
// // //         </div>
// // //       )}

// // //       {/* ── Playing: local MP4 ── */}
// // //       {isPlaying && reel.videoSrc && !reel.ytId && (
// // //         <div className="rl-embed">
// // //           <video
// // //             ref={videoRef}
// // //             src={reel.videoSrc}
// // //             playsInline
// // //             controls
// // //             style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}
// // //           />
// // //           <button className="rl-close" onClick={e => { e.stopPropagation(); onClose(); }}>✕</button>
// // //         </div>
// // //       )}

// // //       {/* ── Thumbnail state (always rendered under embed) ── */}
// // //       {!isPlaying && (
// // //         <>
// // //           {/* Thumbnail image */}
// // //           <img src={reel.img} alt={reel.title} className="rl-thumb" />

// // //           {/* Scanline texture overlay */}
// // //           <div className="rl-scanlines" />

// // //           {/* Dark gradient */}
// // //           <div className="rl-gradient" />

// // //           {/* Views badge */}
// // //           <div className="rl-views-badge">
// // //             <span className="rl-eye">👁</span> {reel.views}
// // //           </div>

// // //           {/* Play button */}
// // //           {hasVideo ? (
// // //             <div className="rl-play-ring">
// // //               <div className="rl-play-ic">
// // //                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
// // //                   <path d="M8 5v14l11-7z"/>
// // //                 </svg>
// // //               </div>
// // //               <div className="rl-play-pulse" />
// // //             </div>
// // //           ) : (
// // //             /* No video yet — show camera icon */
// // //             <div className="rl-soon-ic">
// // //               <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
// // //                 <path d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14M3 8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/>
// // //               </svg>
// // //             </div>
// // //           )}

// // //           {/* Title + tap hint */}
// // //           <div className="rl-info">
// // //             <div className="rl-title">{reel.title}</div>
// // //             {hasVideo && <div className="rl-hint">Tap to watch</div>}
// // //           </div>

// // //           {/* Gold bottom bar on hover */}
// // //           <div className="rl-bar" />
// // //         </>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // /* ─── Main Section ───────────────────────────────────────── */
// // // export default function ReelsSection() {
// // //   const [offset,    setOffset]    = useState(0);
// // //   const [playIdx,   setPlayIdx]   = useState(-1);
// // //   const trackRef  = useRef(null);
// // //   const autoRef   = useRef(null);

// // //   /* auto-scroll (pause when a video is playing) */
// // //   useEffect(() => {
// // //     if (playIdx >= 0) { clearInterval(autoRef.current); return; }
// // //     autoRef.current = setInterval(() => {
// // //       setOffset(o => (o + 1) % REELS.length);
// // //     }, 2800);
// // //     return () => clearInterval(autoRef.current);
// // //   }, [playIdx]);

// // //   const prev = () => { clearInterval(autoRef.current); setOffset(o => (o - 1 + REELS.length) % REELS.length); };
// // //   const next = () => { clearInterval(autoRef.current); setOffset(o => (o + 1) % REELS.length); };

// // //   /* card width + gap for transform calc */
// // //   const CARD_W = 180;
// // //   const GAP    = 14;
// // //   const tx     = `translateX(-${offset * (CARD_W + GAP)}px)`;

// // //   return (
// // //     <>
// // //       <style>{`
// // //         /* ── Section ── */
// // //         .rl-sec {
// // //           padding: 80px 0;
// // //           background: ${C.dark};
// // //           position: relative; overflow: hidden;
// // //         }
// // //         .rl-sec::before {
// // //           content: ''; position: absolute; inset: 0;
// // //           background:
// // //             radial-gradient(ellipse 60% 50% at 10% 50%, rgba(94,14,115,.25) 0%, transparent 65%),
// // //             radial-gradient(ellipse 50% 40% at 90% 50%, rgba(201,168,76,.07) 0%, transparent 65%);
// // //           pointer-events: none;
// // //         }

// // //         /* ── Track wrapper ── */
// // //         .rl-track-outer {
// // //           overflow: hidden;
// // //           padding: 12px 0 20px;
// // //           margin: 0 -8px;
// // //         }
// // //         .rl-track {
// // //           display: flex;
// // //           gap: ${GAP}px;
// // //           transition: transform .6s cubic-bezier(.25,1,.5,1);
// // //           will-change: transform;
// // //         }

// // //         /* ── Card ── */
// // //         .rl-card {
// // //           flex-shrink: 0;
// // //           width: ${CARD_W}px;
// // //           aspect-ratio: 9/16;
// // //           border-radius: 18px;
// // //           overflow: hidden;
// // //           position: relative;
// // //           background: #0D0018;
// // //           border: 1px solid rgba(255,255,255,.07);
// // //           cursor: pointer;
// // //           transition:
// // //             transform .4s cubic-bezier(.25,1,.5,1),
// // //             box-shadow .4s,
// // //             border-color .35s;
// // //         }
// // //         .rl-card:hover {
// // //           transform: translateY(-10px) scale(1.03);
// // //           box-shadow: 0 24px 60px rgba(0,0,0,.6);
// // //           border-color: rgba(201,168,76,.35);
// // //         }
// // //         .rl-playing {
// // //           transform: translateY(-10px) scale(1.04) !important;
// // //           border-color: ${C.gold} !important;
// // //           box-shadow: 0 0 0 2px rgba(201,168,76,.25), 0 28px 72px rgba(0,0,0,.65) !important;
// // //           z-index: 10;
// // //         }

// // //         /* ── Thumbnail ── */
// // //         .rl-thumb {
// // //           position: absolute; inset: 0;
// // //           width: 100%; height: 100%; object-fit: cover; display: block;
// // //           transition: transform .55s cubic-bezier(.25,1,.5,1), filter .4s;
// // //         }
// // //         .rl-card:hover .rl-thumb {
// // //           transform: scale(1.08);
// // //           filter: brightness(.75);
// // //         }

// // //         /* scanlines texture */
// // //         .rl-scanlines {
// // //           position: absolute; inset: 0;
// // //           background: repeating-linear-gradient(
// // //             0deg,
// // //             transparent, transparent 2px,
// // //             rgba(0,0,0,.07) 2px, rgba(0,0,0,.07) 4px
// // //           );
// // //           pointer-events: none;
// // //           opacity: 0;
// // //           transition: opacity .4s;
// // //         }
// // //         .rl-card:hover .rl-scanlines { opacity: 1; }

// // //         /* gradient */
// // //         .rl-gradient {
// // //           position: absolute; inset: 0;
// // //           background: linear-gradient(
// // //             to top,
// // //             rgba(13,0,24,.97) 0%,
// // //             rgba(13,0,24,.4)  40%,
// // //             rgba(13,0,24,.05) 100%
// // //           );
// // //         }

// // //         /* views badge */
// // //         .rl-views-badge {
// // //           position: absolute; top: 12px; left: 12px;
// // //           background: rgba(0,0,0,.55); backdrop-filter: blur(8px);
// // //           border: 1px solid rgba(255,255,255,.1);
// // //           color: #fff; font-size: 10px; font-weight: 600;
// // //           padding: 4px 9px; border-radius: 50px;
// // //           display: flex; align-items: center; gap: 4px;
// // //           letter-spacing: .3px;
// // //           transition: background .3s;
// // //         }
// // //         .rl-card:hover .rl-views-badge {
// // //           background: rgba(201,168,76,.18);
// // //           border-color: rgba(201,168,76,.4);
// // //           color: ${C.goldLight};
// // //         }
// // //         .rl-eye { font-size: 9px; }

// // //         /* play ring */
// // //         .rl-play-ring {
// // //           position: absolute; top: 50%; left: 50%;
// // //           transform: translate(-50%, -50%);
// // //           width: 52px; height: 52px; border-radius: 50%;
// // //           background: rgba(255,255,255,.12);
// // //           backdrop-filter: blur(14px);
// // //           border: 2px solid rgba(255,255,255,.4);
// // //           display: flex; align-items: center; justify-content: center;
// // //           transition: all .35s cubic-bezier(.25,1,.5,1);
// // //           box-shadow: 0 6px 24px rgba(0,0,0,.4);
// // //         }
// // //         .rl-card:hover .rl-play-ring {
// // //           background: ${C.gold};
// // //           border-color: ${C.gold};
// // //           transform: translate(-50%, -50%) scale(1.15);
// // //           box-shadow: 0 10px 36px rgba(201,168,76,.55);
// // //         }
// // //         .rl-play-ic { color: #fff; display: flex; align-items: center; justify-content: center; margin-left: 2px; transition: color .3s; }
// // //         .rl-card:hover .rl-play-ic { color: ${C.dark}; }

// // //         /* pulse ring animation */
// // //         .rl-play-pulse {
// // //           position: absolute;
// // //           width: 52px; height: 52px; border-radius: 50%;
// // //           border: 2px solid rgba(201,168,76,.4);
// // //           animation: rl-pulse 2s ease-in-out infinite;
// // //           opacity: 0;
// // //           transition: opacity .3s;
// // //         }
// // //         .rl-card:hover .rl-play-pulse { opacity: 1; }
// // //         @keyframes rl-pulse {
// // //           0%   { transform: scale(1);    opacity: .7; }
// // //           100% { transform: scale(1.9);  opacity: 0;  }
// // //         }

// // //         /* coming-soon camera icon */
// // //         .rl-soon-ic {
// // //           position: absolute; top: 50%; left: 50%;
// // //           transform: translate(-50%, -50%);
// // //           width: 48px; height: 48px; border-radius: 50%;
// // //           background: rgba(255,255,255,.06);
// // //           border: 1.5px solid rgba(255,255,255,.15);
// // //           display: flex; align-items: center; justify-content: center;
// // //           color: rgba(255,255,255,.35);
// // //           transition: all .3s;
// // //         }
// // //         .rl-card:hover .rl-soon-ic { background: rgba(255,255,255,.1); color: rgba(255,255,255,.6); }

// // //         /* info strip */
// // //         .rl-info {
// // //           position: absolute; bottom: 0; left: 0; right: 0;
// // //           padding: 18px 14px 14px;
// // //         }
// // //         .rl-title {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 13px; font-weight: 700; color: #fff;
// // //           line-height: 1.35; margin-bottom: 4px;
// // //         }
// // //         .rl-hint {
// // //           font-size: 10px; color: rgba(255,255,255,.4);
// // //           letter-spacing: .5px;
// // //           opacity: 0; transform: translateY(4px);
// // //           transition: opacity .3s, transform .3s;
// // //         }
// // //         .rl-card:hover .rl-hint { opacity: 1; transform: translateY(0); }

// // //         /* gold bottom bar */
// // //         .rl-bar {
// // //           position: absolute; bottom: 0; left: 50%;
// // //           width: 0; height: 3px; border-radius: 2px;
// // //           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
// // //           transform: translateX(-50%);
// // //           transition: width .35s cubic-bezier(.25,1,.5,1);
// // //         }
// // //         .rl-card:hover .rl-bar { width: 100%; }

// // //         /* ── Embed (YouTube / local video) ── */
// // //         .rl-embed {
// // //           position: absolute; inset: 0;
// // //           background: #000;
// // //           border-radius: 18px;
// // //           overflow: hidden;
// // //         }
// // //         .rl-embed iframe {
// // //           width: 100%; height: 100%; border: none; display: block;
// // //         }
// // //         .rl-close {
// // //           position: absolute; top: 10px; right: 10px; z-index: 20;
// // //           width: 30px; height: 30px; border-radius: 50%;
// // //           background: rgba(0,0,0,.7); backdrop-filter: blur(8px);
// // //           border: 1px solid rgba(255,255,255,.2);
// // //           color: #fff; font-size: 12px; cursor: pointer;
// // //           display: flex; align-items: center; justify-content: center;
// // //           transition: background .2s;
// // //         }
// // //         .rl-close:hover { background: rgba(201,168,76,.8); color: ${C.dark}; }

// // //         /* ── Arrows ── */
// // //         .rl-arrow {
// // //           width: 46px; height: 46px; border-radius: 50%;
// // //           background: rgba(255,255,255,.07);
// // //           border: 1px solid rgba(255,255,255,.14);
// // //           color: rgba(255,255,255,.7); font-size: 20px; cursor: pointer;
// // //           display: flex; align-items: center; justify-content: center;
// // //           transition: all .25s; backdrop-filter: blur(8px);
// // //         }
// // //         .rl-arrow:hover {
// // //           background: ${C.gold}; color: ${C.dark};
// // //           border-color: ${C.gold};
// // //           box-shadow: 0 6px 20px rgba(201,168,76,.4);
// // //         }

// // //         /* ── Dots ── */
// // //         .rl-dots { display: flex; gap: 6px; align-items: center; }
// // //         .rl-dot {
// // //           width: 6px; height: 6px; border-radius: 50%;
// // //           background: rgba(255,255,255,.18); border: none; cursor: pointer;
// // //           transition: all .3s;
// // //         }
// // //         .rl-dot.on {
// // //           width: 22px; border-radius: 3px;
// // //           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
// // //         }

// // //         /* ── Instagram CTA strip ── */
// // //         .rl-ig {
// // //           margin-top: 44px;
// // //           display: flex; align-items: center; justify-content: space-between;
// // //           flex-wrap: wrap; gap: 16px;
// // //           padding: 22px 32px;
// // //           background: rgba(255,255,255,.03);
// // //           border: 1px solid rgba(255,255,255,.07);
// // //           border-radius: 18px;
// // //         }
// // //         .rl-ig-left { display: flex; align-items: center; gap: 14px; }
// // //         .rl-ig-dot  {
// // //           width: 46px; height: 46px; border-radius: 14px; flex-shrink: 0;
// // //           background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888);
// // //           display: flex; align-items: center; justify-content: center;
// // //           font-size: 20px; color: #fff;
// // //           box-shadow: 0 6px 18px rgba(220,39,67,.35);
// // //         }
// // //         .rl-ig-title { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 2px; }
// // //         .rl-ig-sub   { font-size: 12px; color: rgba(255,255,255,.4); }
// // //         .rl-ig-btn {
// // //           display: inline-flex; align-items: center; gap: 8px;
// // //           padding: 11px 22px; border-radius: 50px;
// // //           background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888);
// // //           color: #fff; font-size: 13px; font-weight: 700;
// // //           text-decoration: none; transition: all .25s;
// // //           box-shadow: 0 4px 16px rgba(220,39,67,.35);
// // //         }
// // //         .rl-ig-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(220,39,67,.5); color: #fff; }

// // //         @media(max-width:576px) {
// // //           .rl-ig { padding: 18px; flex-direction: column; text-align: center; }
// // //           .rl-ig-left { flex-direction: column; }
// // //         }
// // //       `}</style>

// // //       <section className="rl-sec cc-sec" id="reels">
// // //         <div className="container">

// // //           {/* Header */}
// // //           <div className="text-center rv" style={{ marginBottom:48 }}>
// // //             <span className="cc-tag cc-tag-light">✦ Our Celebrations ✦</span>
// // //             <h2 className="cc-h cc-h-white">See the <span className="gold">Magic</span> Happen</h2>
// // //             <p className="cc-sub cc-sub-light">Watch real events — the energy, the joy, the unforgettable moments.</p>
// // //           </div>

// // //           {/* Track */}
// // //           <div className="rl-track-outer">
// // //             <div
// // //               ref={trackRef}
// // //               className="rl-track"
// // //               style={{ transform: tx }}
// // //             >
// // //               {/* duplicate for infinite feel */}
// // //               {[...REELS, ...REELS].map((r, i) => (
// // //                 <ReelCard
// // //                   key={i}
// // //                   reel={r}
// // //                   isPlaying={playIdx === i}
// // //                   onPlay={() => setPlayIdx(i)}
// // //                   onClose={() => setPlayIdx(-1)}
// // //                 />
// // //               ))}
// // //             </div>
// // //           </div>

// // //           {/* Nav */}
// // //           <div style={{ display:"flex", justifyContent:"center", alignItems:"center", gap:16, marginTop:24 }}>
// // //             <button className="rl-arrow" onClick={prev}>‹</button>
// // //             <div className="rl-dots">
// // //               {REELS.map((_,i) => (
// // //                 <button
// // //                   key={i}
// // //                   className={`rl-dot ${i===offset?"on":""}`}
// // //                   onClick={() => { clearInterval(autoRef.current); setOffset(i); }}
// // //                 />
// // //               ))}
// // //             </div>
// // //             <button className="rl-arrow" onClick={next}>›</button>
// // //           </div>

// // //           {/* Instagram CTA */}
// // //           <div className="rl-ig">
// // //             <div className="rl-ig-left">
// // //               <div className="rl-ig-dot">
// // //                 <i className="fab fa-instagram" />
// // //               </div>
// // //               <div>
// // //                 <div className="rl-ig-title">Follow us on Instagram for more moments</div>
// // //                 <div className="rl-ig-sub">@carnival_castle_hyderabad · 50K+ followers</div>
// // //               </div>
// // //             </div>
// // //             <a
// // //               href="https://www.instagram.com/carnival_castle_hyderabad/"
// // //               target="_blank" rel="noopener noreferrer"
// // //               className="rl-ig-btn"
// // //             >
// // //               <i className="fab fa-instagram" /> Follow Now
// // //             </a>
// // //           </div>

// // //         </div>
// // //       </section>
// // //     </>
// // //   );
// // // }

// // // import React, { useState, useEffect, useRef } from "react";

// // // const C = {
// // //   primary: "#5E0E73",
// // //   gold: "#C9A84C",
// // //   goldLight: "#E8D5A0",
// // //   dark: "#1A0030",
// // // };

// // // /* ═══════════════════════════════════════════════════════════
// // //    INSTAGRAM REELS
// // // ═══════════════════════════════════════════════════════════ */

// // // const REELS = [
// // //    {
// // //     views: "124K",
// // //     title: "Royal Birthday Setup",

// // //     video:
// // //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // //   },
// // //   {
// // //     views: "89K",
// // //     title: "Surprise Proposal",
// // //     video:
// // //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Surprise_Proposal_carnivalcastle_ohoj2o.mp4",
// // //   },
// // //   {
// // //     views: "203K",
// // //     title: "Fog Entry Magic",
// // //     video:
// // //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Fog_Entry_Magic_carnivalcastle_ohoj2o.mp4",
// // //   },
// // //   {
// // //     views: "67K",
// // //     title: "Anniversary Night",
// // //     video:
// // //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Anniversary_Night_carnivalcastle_ohoj2o.mp4",
// // //   },
// // //   {
// // //     views: "91K",
// // //     title: "Floral Decor Setup",
// // //     video:
// // //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Floral_Decor_Setup_carnivalcastle_ohoj2o.mp4",
// // //   },
// // // ];

// // // /* ─── Reel Card ───────────────────────────────────────── */

// // // function ReelCard({ reel }) {
// // //   return (
// // //     <div className="rl-card">

// // //       {/* Video */}
// // //       <video
// // //         className="rl-video"
// // //         src={reel.video}
// // //         autoPlay
// // //         muted
// // //         loop
// // //         playsInline
// // //         controls={false}
// // //       />

// // //       {/* Overlay */}
// // //       <div className="rl-overlay" />

// // //       {/* Views */}
// // //       <div className="rl-views-badge">
// // //         <span className="rl-eye">👁</span>
// // //         {reel.views}
// // //       </div>

// // //       {/* Title */}
// // //       <div className="rl-info">
// // //         <div className="rl-title">{reel.title}</div>
// // //       </div>

// // //     </div>
// // //   );
// // // }

// // // /* ─── Main Section ───────────────────────────────────── */

// // // export default function ReelsSection() {
// // //   const [offset, setOffset] = useState(0);
// // //   const autoRef = useRef(null);

// // //   const CARD_W = 240;
// // //   const GAP = 18;

// // //   /* Auto Scroll */
// // //   useEffect(() => {
// // //     autoRef.current = setInterval(() => {
// // //       setOffset((o) => (o + 1) % REELS.length);
// // //     }, 3500);

// // //     return () => clearInterval(autoRef.current);
// // //   }, []);

// // //   const prev = () => {
// // //     clearInterval(autoRef.current);
// // //     setOffset((o) => (o - 1 + REELS.length) % REELS.length);
// // //   };

// // //   const next = () => {
// // //     clearInterval(autoRef.current);
// // //     setOffset((o) => (o + 1) % REELS.length);
// // //   };

// // //   const tx = `translateX(-${offset * (CARD_W + GAP)}px)`;

// // //   return (
// // //     <>
// // //       <style>{`
      
// // //         /* ───────────────── SECTION ───────────────── */

// // //         .rl-sec {
// // //           padding: 90px 0;
// // //           background: ${C.dark};
// // //           position: relative;
// // //           overflow: hidden;
// // //         }

// // //         .rl-sec::before {
// // //           content: '';
// // //           position: absolute;
// // //           inset: 0;
// // //           background:
// // //             radial-gradient(circle at left, rgba(94,14,115,.22), transparent 45%),
// // //             radial-gradient(circle at right, rgba(201,168,76,.08), transparent 40%);
// // //           pointer-events: none;
// // //         }

// // //         /* ───────────────── HEADER ───────────────── */

// // //         .rl-head {
// // //           text-align: center;
// // //           margin-bottom: 50px;
// // //         }

// // //         .rl-tag {
// // //           color: ${C.goldLight};
// // //           font-size: 13px;
// // //           letter-spacing: 1px;
// // //           margin-bottom: 12px;
// // //           display: inline-block;
// // //         }

// // //         .rl-head h2 {
// // //           color: white;
// // //           font-size: 42px;
// // //           margin: 0;
// // //           font-weight: 800;
// // //         }

// // //         .rl-head h2 span {
// // //           color: ${C.gold};
// // //         }

// // //         .rl-sub {
// // //           color: rgba(255,255,255,.65);
// // //           margin-top: 14px;
// // //           font-size: 15px;
// // //         }

// // //         /* ───────────────── TRACK ───────────────── */

// // //         .rl-track-wrap {
// // //           overflow: hidden;
// // //           padding: 10px 0 20px;
// // //         }

// // //         .rl-track {
// // //           display: flex;
// // //           gap: ${GAP}px;
// // //           transition: transform .7s cubic-bezier(.25,1,.5,1);
// // //         }

// // //         /* ───────────────── CARD ───────────────── */

// // //         .rl-card {
// // //           width: ${CARD_W}px;
// // //           aspect-ratio: 9/16;
// // //           flex-shrink: 0;

// // //           position: relative;
// // //           overflow: hidden;

// // //           border-radius: 24px;

// // //           background: #000;

// // //           border: 1px solid rgba(255,255,255,.08);

// // //           transition:
// // //             transform .4s ease,
// // //             box-shadow .4s ease,
// // //             border-color .4s ease;
// // //         }

// // //         .rl-card:hover {
// // //           transform: translateY(-10px) scale(1.03);

// // //           border-color: rgba(201,168,76,.4);

// // //           box-shadow:
// // //             0 24px 60px rgba(0,0,0,.6),
// // //             0 0 30px rgba(201,168,76,.15);
// // //         }

// // //         /* ───────────────── VIDEO ───────────────── */

// // //         .rl-embed {
// // //           position: absolute;
// // //           inset: 0;
// // //         }

// // //         .rl-embed iframe {
// // //           width: 100%;
// // //           height: 100%;
// // //           border: none;
// // //           display: block;
// // //           background: #000;
// // //         }

// // //         /* ───────────────── OVERLAY ───────────────── */

// // //         .rl-overlay {
// // //           position: absolute;
// // //           inset: 0;

// // //           background: linear-gradient(
// // //             to top,
// // //             rgba(0,0,0,.85) 0%,
// // //             rgba(0,0,0,.25) 45%,
// // //             rgba(0,0,0,.08) 100%
// // //           );

// // //           pointer-events: none;
// // //         }

// // //         /* ───────────────── VIEWS ───────────────── */

// // //         .rl-views-badge {
// // //           position: absolute;
// // //           top: 14px;
// // //           left: 14px;
// // //           z-index: 5;

// // //           background: rgba(0,0,0,.55);

// // //           border: 1px solid rgba(255,255,255,.12);

// // //           backdrop-filter: blur(10px);

// // //           color: white;

// // //           font-size: 11px;
// // //           font-weight: 700;

// // //           padding: 6px 11px;

// // //           border-radius: 999px;

// // //           display: flex;
// // //           align-items: center;
// // //           gap: 5px;
// // //         }

// // //         .rl-eye {
// // //           font-size: 10px;
// // //         }

// // //         /* ───────────────── INFO ───────────────── */

// // //         .rl-info {
// // //           position: absolute;
// // //           left: 0;
// // //           right: 0;
// // //           bottom: 0;

// // //           z-index: 5;

// // //           padding: 18px;
// // //         }

// // //         .rl-title {
// // //           color: white;

// // //           font-size: 15px;
// // //           font-weight: 700;

// // //           line-height: 1.4;
// // //         }

// // //         /* ───────────────── NAV ───────────────── */

// // //         .rl-nav {
// // //           margin-top: 30px;

// // //           display: flex;
// // //           align-items: center;
// // //           justify-content: center;

// // //           gap: 16px;
// // //         }

// // //         .rl-arrow {
// // //           width: 48px;
// // //           height: 48px;

// // //           border-radius: 50%;

// // //           border: 1px solid rgba(255,255,255,.12);

// // //           background: rgba(255,255,255,.06);

// // //           color: white;

// // //           font-size: 22px;

// // //           cursor: pointer;

// // //           transition: .3s ease;
// // //         }

// // //         .rl-arrow:hover {
// // //           background: ${C.gold};
// // //           color: #111;
// // //           border-color: ${C.gold};
// // //         }

// // //         .rl-dots {
// // //           display: flex;
// // //           gap: 8px;
// // //         }

// // //         .rl-dot {
// // //           width: 8px;
// // //           height: 8px;

// // //           border-radius: 999px;

// // //           border: none;

// // //           background: rgba(255,255,255,.2);

// // //           transition: .3s ease;

// // //           cursor: pointer;
// // //         }

// // //         .rl-dot.active {
// // //           width: 24px;

// // //           background: linear-gradient(
// // //             90deg,
// // //             ${C.primary},
// // //             ${C.gold}
// // //           );
// // //         }

// // //         /* ───────────────── MOBILE ───────────────── */

// // //         @media(max-width:768px){

// // //           .rl-head h2{
// // //             font-size:32px;
// // //           }

// // //           .rl-card{
// // //             width:190px;
// // //           }

// // //         }

// // //       `}</style>

// // //       <section className="rl-sec">

// // //         <div className="container">

// // //           {/* Header */}

// // //           <div className="rl-head">
// // //             <div className="rl-tag">
// // //               ✦ OUR INSTAGRAM REELS ✦
// // //             </div>

// // //             <h2>
// // //               Watch The <span>Celebration</span>
// // //             </h2>

// // //             <div className="rl-sub">
// // //               Real moments. Real emotions. Real celebrations.
// // //             </div>
// // //           </div>

// // //           {/* Slider */}

// // //           <div className="rl-track-wrap">

// // //             <div
// // //               className="rl-track"
// // //               style={{
// // //                 transform: tx,
// // //               }}
// // //             >

// // //               {[...REELS, ...REELS].map((reel, i) => (
// // //                 <ReelCard
// // //                   key={i}
// // //                   reel={reel}
// // //                 />
// // //               ))}

// // //             </div>

// // //           </div>

// // //           {/* Navigation */}

// // //           <div className="rl-nav">

// // //             <button
// // //               className="rl-arrow"
// // //               onClick={prev}
// // //             >
// // //               ‹
// // //             </button>

// // //             <div className="rl-dots">

// // //               {REELS.map((_, i) => (
// // //                 <button
// // //                   key={i}
// // //                   onClick={() => setOffset(i)}
// // //                   className={`rl-dot ${i === offset ? "active" : ""}`}
// // //                 />
// // //               ))}

// // //             </div>

// // //             <button
// // //               className="rl-arrow"
// // //               onClick={next}
// // //             >
// // //               ›
// // //             </button>

// // //           </div>

// // //         </div>

// // //       </section>
// // //     </>
// // //   );
// // // }


// // import React from "react";

// // const REELS = [
// //   {
// //     views: "124K",
// //     title: "Royal Anniversary Setup",
// //     video:
// //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// //   },

// //   {
// //     views: "89K",
// //     title: "Romantic Candle Dinner",
// //     video:
// //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// //   },

// //   {
// //     views: "203K",
// //     title: "Birthday Celebration",
// //     video:
// //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// //   },

// //   {
// //     views: "67K",
// //     title: "Luxury Decoration",
// //     video:
// //       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// //   },
// // ];

// // /* ───────────────── Reel Card ───────────────── */

// // function ReelCard({ reel }) {
// //   return (
// //     <div className="rl-card">

// //       {/* Video */}
// //       <video
// //         className="rl-video"
// //         src={reel.video}
// //         autoPlay
// //         muted
// //         loop
// //         playsInline
// //         preload="auto"
// //         controls={false}
// //       />

// //       {/* Overlay */}
// //       <div className="rl-overlay" />

// //       {/* Views */}
// //       <div className="rl-views">
// //         👁 {reel.views}
// //       </div>

// //       {/* Bottom Info */}
// //       <div className="rl-info">
// //         <h3>{reel.title}</h3>
// //       </div>

// //     </div>
// //   );
// // }

// // /* ───────────────── Main Component ───────────────── */

// // export default function InstagramReelsSection() {
// //   return (
// //     <>
// //       <style>{`

// //         .rl-section{
// //           padding:90px 0;
// //           background:#120020;
// //           overflow:hidden;
// //           position:relative;
// //         }

// //         .rl-section::before{
// //           content:'';
// //           position:absolute;
// //           inset:0;

// //           background:
// //             radial-gradient(circle at left, rgba(94,14,115,.28), transparent 45%),
// //             radial-gradient(circle at right, rgba(201,168,76,.08), transparent 40%);

// //           pointer-events:none;
// //         }

// //         .rl-container{
// //           width:min(1400px,92%);
// //           margin:auto;
// //           position:relative;
// //           z-index:2;
// //         }

// //         /* ───────────────── HEADER ───────────────── */

// //         .rl-header{
// //           text-align:center;
// //           margin-bottom:48px;
// //         }

// //         .rl-tag{
// //           display:inline-block;
// //           color:#E8D5A0;
// //           font-size:13px;
// //           letter-spacing:1px;
// //           margin-bottom:14px;
// //         }

// //         .rl-title{
// //           color:#fff;
// //           font-size:48px;
// //           font-weight:800;
// //           line-height:1.1;
// //           margin:0;
// //         }

// //         .rl-title span{
// //           color:#C9A84C;
// //         }

// //         .rl-sub{
// //           margin-top:16px;
// //           color:rgba(255,255,255,.65);
// //           font-size:15px;
// //         }

// //         /* ───────────────── REELS TRACK ───────────────── */

// //         .rl-track{
// //           display:flex;
// //           gap:20px;

// //           overflow-x:auto;

// //           scroll-snap-type:x mandatory;

// //           padding-bottom:10px;

// //           scrollbar-width:none;

// //           -webkit-overflow-scrolling:touch;
// //         }

// //         .rl-track::-webkit-scrollbar{
// //           display:none;
// //         }

// //         /* ───────────────── CARD ───────────────── */

// //         .rl-card{
// //           position:relative;

// //           width:260px;
// //           min-width:260px;

// //           height:470px;

// //           overflow:hidden;

// //           border-radius:28px;

// //           background:#000;

// //           scroll-snap-align:center;

// //           border:1px solid rgba(255,255,255,.08);

// //           transition:
// //             transform .35s ease,
// //             box-shadow .35s ease,
// //             border-color .35s ease;
// //         }

// //         .rl-card:hover{
// //           transform:translateY(-8px) scale(1.02);

// //           border-color:rgba(201,168,76,.45);

// //           box-shadow:
// //             0 25px 70px rgba(0,0,0,.6),
// //             0 0 30px rgba(201,168,76,.12);
// //         }

// //         /* ───────────────── VIDEO ───────────────── */

// //         .rl-video{
// //           position:absolute;
// //           inset:0;

// //           width:100%;
// //           height:100%;

// //           object-fit:cover;
// //           object-position:center;

// //           display:block;

// //           background:#000;
// //         }

// //         /* ───────────────── OVERLAY ───────────────── */

// //         .rl-overlay{
// //           position:absolute;
// //           inset:0;

// //           background:linear-gradient(
// //             to top,
// //             rgba(0,0,0,.88) 0%,
// //             rgba(0,0,0,.18) 45%,
// //             rgba(0,0,0,.05) 100%
// //           );

// //           pointer-events:none;
// //         }

// //         /* ───────────────── VIEWS ───────────────── */

// //         .rl-views{
// //           position:absolute;
// //           top:14px;
// //           left:14px;

// //           z-index:5;

// //           padding:6px 12px;

// //           border-radius:999px;

// //           background:rgba(0,0,0,.45);

// //           backdrop-filter:blur(10px);

// //           border:1px solid rgba(255,255,255,.1);

// //           color:#fff;

// //           font-size:11px;
// //           font-weight:700;
// //         }

// //         /* ───────────────── INFO ───────────────── */

// //         .rl-info{
// //           position:absolute;

// //           left:0;
// //           right:0;
// //           bottom:0;

// //           z-index:5;

// //           padding:20px;
// //         }

// //         .rl-info h3{
// //           margin:0;

// //           color:#fff;

// //           font-size:16px;
// //           font-weight:700;

// //           line-height:1.4;
// //         }

// //         /* ───────────────── MOBILE ───────────────── */

// //         @media(max-width:768px){

// //           .rl-title{
// //             font-size:34px;
// //           }

// //           .rl-card{
// //             width:220px;
// //             min-width:220px;
// //             height:400px;
// //           }

// //         }

// //       `}</style>

// //       <section className="rl-section">

// //         <div className="rl-container">

// //           {/* Header */}

// //           <div className="rl-header">

// //             <div className="rl-tag">
// //               ✦ INSTAGRAM REELS ✦
// //             </div>

// //             <h2 className="rl-title">
// //               Watch The <span>Celebration</span>
// //             </h2>

// //             <div className="rl-sub">
// //               Real events. Real emotions. Real unforgettable moments.
// //             </div>

// //           </div>

// //           {/* Reels */}

// //           <div className="rl-track">

// //             {REELS.map((reel, index) => (
// //               <ReelCard
// //                 key={index}
// //                 reel={reel}
// //               />
// //             ))}

// //           </div>

// //         </div>

// //       </section>
// //     </>
// //   );
// // }


// import React, { useEffect, useRef } from "react";

// const REELS = [
//   {
//     views: "124K",
//     title: "Royal Anniversary Setup",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },

//   {
//     views: "89K",
//     title: "Romantic Candle Dinner",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },

//   {
//     views: "203K",
//     title: "Birthday Celebration",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },

//   {
//     views: "67K",
//     title: "Luxury Decoration",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },
//   {
//     views: "203K",
//     title: "Birthday Celebration",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },

//   {
//     views: "67K",
//     title: "Luxury Decoration",
//     video:
//       "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
//   },
// ];

// /* ───────────────── Reel Card ───────────────── */

// function ReelCard({ reel }) {
//   return (
//     <div className="rl-card">

//       {/* Video */}
//       <video
//         className="rl-video"
//         src={reel.video}
//         autoPlay
//         muted
//         loop
//         playsInline
//         preload="auto"
//         controls={false}
//       />

//       {/* Overlay */}
//       <div className="rl-overlay" />

//       {/* Views */}
//       <div className="rl-views">
//         👁 {reel.views}
//       </div>

//       {/* Bottom Info */}
//       <div className="rl-info">
//         <h3>{reel.title}</h3>
//       </div>

//     </div>
//   );
// }

// /* ───────────────── Main Component ───────────────── */

// export default function InstagramReelsSection() {

//   const trackRef = useRef(null);

//   /* ───────────────── AUTO SLIDE ───────────────── */

//   useEffect(() => {

//     const track = trackRef.current;

//     if (!track) return;

//     let scrollAmount = 0;

//     const autoSlide = setInterval(() => {

//       const cardWidth = 280;

//       scrollAmount += cardWidth;

//       if (
//         scrollAmount >=
//         track.scrollWidth - track.clientWidth
//       ) {
//         scrollAmount = 0;
//       }

//       track.scrollTo({
//         left: scrollAmount,
//         behavior: "smooth",
//       });

//     }, 3000);

//     return () => clearInterval(autoSlide);

//   }, []);

//   return (
//     <>
//       <style>{`

//         .rl-section{
//           padding:90px 0;
//           background:#120020;
//           overflow:hidden;
//           position:relative;
//         }

//         .rl-section::before{
//           content:'';
//           position:absolute;
//           inset:0;

//           background:
//             radial-gradient(circle at left, rgba(94,14,115,.28), transparent 45%),
//             radial-gradient(circle at right, rgba(201,168,76,.08), transparent 40%);

//           pointer-events:none;
//         }

//         .rl-container{
//           width:min(1400px,92%);
//           margin:auto;
//           position:relative;
//           z-index:2;
//         }

//         /* ───────────────── HEADER ───────────────── */

//         .rl-header{
//           text-align:center;
//           margin-bottom:48px;
//         }

//         .rl-tag{
//           display:inline-block;
//           color:#E8D5A0;
//           font-size:13px;
//           letter-spacing:1px;
//           margin-bottom:14px;
//         }

//         .rl-title{
//           color:#fff;
//           font-size:48px;
//           font-weight:800;
//           line-height:1.1;
//           margin:0;
//         }

//         .rl-title span{
//           color:#C9A84C;
//         }

//         .rl-sub{
//           margin-top:16px;
//           color:rgba(255,255,255,.65);
//           font-size:15px;
//         }

//         /* ───────────────── TRACK ───────────────── */

//         .rl-track{
//           display:flex;
//           gap:20px;

//           overflow-x:auto;

//           scroll-snap-type:x mandatory;

//           padding-bottom:10px;

//           scrollbar-width:none;

//           -webkit-overflow-scrolling:touch;

//           scroll-behavior:smooth;
//         }

//         .rl-track::-webkit-scrollbar{
//           display:none;
//         }

//         /* ───────────────── CARD ───────────────── */

//         .rl-card{
//           position:relative;

//           width:260px;
//           min-width:260px;

//           height:470px;

//           overflow:hidden;

//           border-radius:28px;

//           background:#000;

//           scroll-snap-align:center;

//           border:1px solid rgba(255,255,255,.08);

//           transition:
//             transform .35s ease,
//             box-shadow .35s ease,
//             border-color .35s ease;

//           flex-shrink:0;
//         }

//         .rl-card:hover{
//           transform:translateY(-8px) scale(1.02);

//           border-color:rgba(201,168,76,.45);

//           box-shadow:
//             0 25px 70px rgba(0,0,0,.6),
//             0 0 30px rgba(201,168,76,.12);
//         }

//         /* ───────────────── VIDEO ───────────────── */

//         .rl-video{
//           position:absolute;
//           inset:0;

//           width:100%;
//           height:100%;

//           object-fit:cover;
//           object-position:center;

//           display:block;

//           background:#000;
//         }

//         /* ───────────────── OVERLAY ───────────────── */

//         .rl-overlay{
//           position:absolute;
//           inset:0;

//           background:linear-gradient(
//             to top,
//             rgba(0,0,0,.88) 0%,
//             rgba(0,0,0,.18) 45%,
//             rgba(0,0,0,.05) 100%
//           );

//           pointer-events:none;
//         }

//         /* ───────────────── VIEWS ───────────────── */

//         .rl-views{
//           position:absolute;
//           top:14px;
//           left:14px;

//           z-index:5;

//           padding:6px 12px;

//           border-radius:999px;

//           background:rgba(0,0,0,.45);

//           backdrop-filter:blur(10px);

//           border:1px solid rgba(255,255,255,.1);

//           color:#fff;

//           font-size:11px;
//           font-weight:700;
//         }

//         /* ───────────────── INFO ───────────────── */

//         .rl-info{
//           position:absolute;

//           left:0;
//           right:0;
//           bottom:0;

//           z-index:5;

//           padding:20px;
//         }

//         .rl-info h3{
//           margin:0;

//           color:#fff;

//           font-size:16px;
//           font-weight:700;

//           line-height:1.4;
//         }

//         /* ───────────────── MOBILE ───────────────── */

//         @media(max-width:768px){

//           .rl-title{
//             font-size:34px;
//           }

//           .rl-card{
//             width:220px;
//             min-width:220px;
//             height:400px;
//           }

//         }

//       `}</style>

//       <section className="rl-section">

//         <div className="rl-container">

//           {/* Header */}

//           <div className="rl-header">

//             <div className="rl-tag">
//               ✦ INSTAGRAM REELS ✦
//             </div>

//             <h2 className="rl-title">
//               Watch The <span>Celebration</span>
//             </h2>

//             <div className="rl-sub">
//               Real events. Real emotions. Real unforgettable moments.
//             </div>

//           </div>

//           {/* Reels */}

//           <div
//             className="rl-track"
//             ref={trackRef}
//           >

//             {REELS.map((reel, index) => (
//               <ReelCard
//                 key={index}
//                 reel={reel}
//               />
//             ))}

//           </div>

//         </div>

//       </section>
//     </>
//   );
// }


import React, { useState, useEffect, useRef } from "react";

const REELS = [
  {
    views: "124K",
    title: "Royal Anniversary Setup",
    tag: "Anniversary",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
  },
  {
    views: "89K",
    title: "Romantic Proposal",
    tag: "Romance",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221238/Memorable_moment_%EF%B8%8F_proposal_couple_love_explore_memory_carnival_castle_Experience_the_mos_etnmec.mp4",
  },
  {
    views: "203K",
    title: "Birthday Celebration",
    tag: "Birthday",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221257/Celebrate_your_event_carnival_castle__Contact-_8341428342_9059382797Experience_the_most_unique_qjnpzy.mp4",
  },
  {
    views: "67K",
    title: "Bride To Be",
    tag: "Luxury",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221682/Bride_To_Be_Celebration_in_Hyderabad_-_Budget-Friendly_Luxury_Private_Party_Venue_Plannin_pnqc3y.mp4",
  },
  {
    views: "156K",
    title: "Kids Theme Party",
    tag: "Kids Party",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779222121/Celebrate_Lakshith_s_1st_Birthday_in_a_joyful_and_magical_way_at_Carnival_Castle_Private_Theatre_bupm9c.mp4",
  },
  {
    views: "91K",
    title: "Movies",
    tag: "Movie preview",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221809/Hero_Suman_Prabhas_laanti_celebrities_ki_telisina_Carnival_Castle_Celebrities_trust_chesina_ce_sequks.mp4",
  },
];

const CARD_W = 260;
const GAP    = 20;
const STEP   = CARD_W + GAP;

export default function InstagramReelsSection() {
  const [idx,     setIdx]     = useState(0);
  const [hovered, setHovered] = useState(false);
  const timerRef = useRef(null);

  /* ── visible count based on viewport ── */
  const [visCount, setVisCount] = useState(4);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      setVisCount(w < 540 ? 1 : w < 768 ? 2 : w < 1100 ? 3 : 4);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const maxIdx = REELS.length - visCount;

  /* ── auto-slide ── */
  const startTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setIdx(i => (i >= maxIdx ? 0 : i + 1));
    }, 3000);
  };

  useEffect(() => {
    if (!hovered) startTimer();
    else clearInterval(timerRef.current);
    return () => clearInterval(timerRef.current);
  }, [hovered, maxIdx]);

  const prev = () => { setIdx(i => Math.max(0, i - 1)); startTimer(); };
  const next = () => { setIdx(i => (i >= maxIdx ? 0 : i + 1)); startTimer(); };

  const translateX = -(idx * STEP);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600;700&display=swap');

        :root {
          --dark:  #120020;
          --dark2: #1A0030;
          --p:     #5E0E73;
          --pl:    #6E1A85;
          --gold:  #C9A84C;
          --gl:    #E8D5A0;
          --gb:    #F5D87A;
        }

        /* ─── keyframes ─── */
        @keyframes rl-goldBg {
          0%,100% { background-position: 0% 50%; }
          50%      { background-position: 100% 50%; }
        }
        @keyframes rl-shine {
          0%   { left: -100%; }
          25%  { left: 130%; }
          100% { left: 130%; }
        }
        @keyframes rl-fadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes rl-float {
          0%,100% { transform: translateY(0); }
          50%      { transform: translateY(-10px); }
        }
        @keyframes rl-pulse {
          0%,100% { opacity: .4; transform: scale(1); }
          50%      { opacity: .8; transform: scale(1.08); }
        }

        /* ─── section ─── */
        .rl-section {
          padding: 100px 0 110px;
          background: var(--dark);
          overflow: hidden;
          position: relative;
          font-family: 'DM Sans', sans-serif;
        }

        /* decorative orbs */
        .rl-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          pointer-events: none;
          animation: rl-pulse 6s ease-in-out infinite;
        }

        /* noise grain overlay */
        .rl-section::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.03'/%3E%3C/svg%3E");
          pointer-events: none;
          opacity: .4;
        }

        .rl-container {
          width: min(1320px, 92%);
          margin: auto;
          position: relative;
          z-index: 2;
        }

        /* ─── header ─── */
        .rl-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 52px;
          flex-wrap: wrap;
          gap: 20px;
          animation: rl-fadeUp .8s cubic-bezier(.16,1,.3,1) both;
        }

        .rl-header-left {}

        .rl-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: var(--gl);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 14px;
        }
        .rl-eyebrow-line {
          width: 32px;
          height: 1px;
          background: var(--gold);
          opacity: .6;
        }

        .rl-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 54px);
          font-weight: 900;
          color: #fff;
          line-height: 1.08;
          margin: 0 0 10px;
          letter-spacing: -.5px;
        }
        .rl-title em {
          font-style: italic;
          color: var(--gold);
        }

        .rl-sub {
          color: rgba(255,255,255,.5);
          font-size: 15px;
          line-height: 1.6;
          max-width: 400px;
        }

        /* ─── nav arrows ─── */
        .rl-nav {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        .rl-nav-btn {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: rgba(255,255,255,.06);
          border: 1.5px solid rgba(255,255,255,.14);
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .25s;
          font-weight: 700;
          flex-shrink: 0;
        }
        .rl-nav-btn:hover {
          background: var(--gold);
          color: var(--dark);
          border-color: var(--gold);
          transform: scale(1.08);
        }

        /* ─── carousel ─── */
        .rl-carousel-wrap {
          overflow: hidden;
          width: 100%;
        }

        .rl-track {
          display: flex;
          gap: ${GAP}px;
          transition: transform .65s cubic-bezier(.25,1,.5,1);
          will-change: transform;
        }

        /* ─── card ─── */
        .rl-card {
          position: relative;
          width: ${CARD_W}px;
          min-width: ${CARD_W}px;
          height: 470px;
          border-radius: 26px;
          overflow: hidden;
          background: #000;
          border: 1px solid rgba(255,255,255,.07);
          transition: transform .4s cubic-bezier(.25,1,.5,1), box-shadow .4s, border-color .4s;
          flex-shrink: 0;
          cursor: pointer;
        }
        .rl-card:hover {
          transform: translateY(-10px) scale(1.02);
          border-color: rgba(201,168,76,.5);
          box-shadow: 0 30px 70px rgba(0,0,0,.55), 0 0 40px rgba(201,168,76,.1);
        }

        /* ─── video ─── */
        .rl-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        /* ─── gradient overlay ─── */
        .rl-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(13,0,24,.95) 0%,
            rgba(13,0,24,.4)  45%,
            rgba(13,0,24,.08) 100%
          );
          pointer-events: none;
        }

        /* ─── views badge ─── */
        .rl-views {
          position: absolute;
          top: 14px;
          left: 14px;
          z-index: 5;
          padding: 5px 11px;
          border-radius: 999px;
          background: rgba(0,0,0,.5);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,.12);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          font-family: 'DM Sans', sans-serif;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        /* ─── play button ─── */
        .rl-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(.85);
          z-index: 5;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: rgba(201,168,76,.9);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          opacity: 0;
          transition: all .3s;
          box-shadow: 0 8px 28px rgba(201,168,76,.5);
        }
        .rl-card:hover .rl-play {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }

        /* ─── bottom info ─── */
        .rl-info {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 5;
          padding: 20px 18px 22px;
        }

        .rl-tag-pill {
          display: inline-block;
          background: rgba(201,168,76,.2);
          border: 1px solid rgba(201,168,76,.45);
          color: var(--gold);
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          padding: 3px 10px;
          border-radius: 50px;
          margin-bottom: 8px;
        }

        .rl-info h3 {
          margin: 0;
          color: #fff;
          font-family: 'Playfair Display', serif;
          font-size: 17px;
          font-weight: 700;
          line-height: 1.3;
        }

        /* ─── gold shimmer border on hover ─── */
        .rl-card::after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 26px;
          border: 1.5px solid transparent;
          background: linear-gradient(135deg, rgba(201,168,76,.6), transparent 60%) border-box;
          -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude;
          opacity: 0;
          transition: opacity .4s;
          pointer-events: none;
        }
        .rl-card:hover::after { opacity: 1; }

        /* ─── dots ─── */
        .rl-dots {
          display: flex;
          gap: 8px;
          justify-content: center;
          margin-top: 36px;
        }
        .rl-dot {
          height: 8px;
          border-radius: 4px;
          background: rgba(255,255,255,.2);
          border: none;
          cursor: pointer;
          transition: all .4s;
        }
        .rl-dot.active {
          width: 28px !important;
          background: linear-gradient(90deg, var(--gold), var(--gl));
        }

        /* ─── bottom CTA strip ─── */
        .rl-cta-strip {
          margin-top: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;
          animation: rl-fadeUp .8s cubic-bezier(.16,1,.3,1) .3s both;
        }

        .rl-btn-gold {
          position: relative;
          overflow: hidden;
          background: linear-gradient(135deg, #B8860B, var(--gold), var(--gb), var(--gold), #9A6E10);
          background-size: 200% 200%;
          animation: rl-goldBg 3s ease infinite;
          color: var(--dark);
          border: none;
          border-radius: 50px;
          padding: 13px 30px;
          font-weight: 800;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 6px 24px rgba(201,168,76,.4);
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'DM Sans', sans-serif;
          transition: transform .3s, box-shadow .3s;
          text-decoration: none;
        }
        .rl-btn-gold::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 55%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
          animation: rl-shine 3s ease infinite;
        }
        .rl-btn-gold:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(201,168,76,.55);
        }

        .rl-btn-ig {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          border: 1.5px solid rgba(255,255,255,.2);
          background: rgba(255,255,255,.05);
          backdrop-filter: blur(8px);
          color: #fff;
          border-radius: 50px;
          padding: 12px 28px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          font-family: 'DM Sans', sans-serif;
          text-decoration: none;
          transition: all .3s;
        }
        .rl-btn-ig:hover {
          border-color: rgba(201,168,76,.5);
          background: rgba(201,168,76,.08);
          color: var(--gold);
          transform: translateY(-2px);
        }

        /* ─── responsive ─── */
        @media(max-width:768px) {
          .rl-section  { padding: 70px 0 80px; }
          .rl-header   { margin-bottom: 36px; }
          .rl-title    { font-size: clamp(28px,7vw,38px); }
          .rl-nav      { margin-top: 4px; }
        }

        @media(max-width:540px) {
          .rl-card { height: 420px; }
          .rl-info h3 { font-size: 15px; }
          .rl-nav-btn { width: 40px; height: 40px; font-size: 17px; }
        }
      `}</style>

      <section className="rl-section">

        {/* decorative orbs */}
        <div className="rl-orb" style={{ width:460, height:460, background:"radial-gradient(circle,rgba(94,14,115,.28) 0%,transparent 70%)", top:-80, left:-80, animationDelay:"0s" }} />
        <div className="rl-orb" style={{ width:320, height:320, background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)", bottom:-60, right:-40, animationDelay:"3s" }} />

        <div className="rl-container">

          {/* ── HEADER ── */}
          <div className="rl-header">
            <div className="rl-header-left">
              <div className="rl-eyebrow">
                <div className="rl-eyebrow-line" />
                Instagram Reels
                <div className="rl-eyebrow-line" />
              </div>
              <h2 className="rl-title">
                Watch the <em>Celebrations</em><br />Come Alive
              </h2>
              <p className="rl-sub">
                Real events. Real emotions. Real unforgettable moments — straight from our Instagram.
              </p>
            </div>

            <div className="rl-nav">
              <button className="rl-nav-btn" onClick={prev} aria-label="Previous">‹</button>
              <button className="rl-nav-btn" onClick={next} aria-label="Next">›</button>
            </div>
          </div>

          {/* ── CAROUSEL ── */}
          <div
            className="rl-carousel-wrap"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <div
              className="rl-track"
              style={{ transform: `translateX(${translateX}px)` }}
            >
              {REELS.map((reel, i) => (
                <div key={i} className="rl-card">
                  <video
                    className="rl-video"
                    src={reel.video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                  />
                  <div className="rl-overlay" />
                  <div className="rl-views">👁 {reel.views}</div>
                  <div className="rl-play">▶</div>
                  <div className="rl-info">
                    <div className="rl-tag-pill">{reel.tag}</div>
                    <h3>{reel.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── DOTS ── */}
          <div className="rl-dots">
            {Array.from({ length: REELS.length - visCount + 1 }).map((_, i) => (
              <button
                key={i}
                className={`rl-dot${i === idx ? " active" : ""}`}
                style={{ width: i === idx ? 28 : 8 }}
                onClick={() => { setIdx(i); startTimer(); }}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>

          {/* ── CTA STRIP ── */}
          <div className="rl-cta-strip">
            <a
              href="https://www.instagram.com/carnival_castle_/"
              target="_blank"
              rel="noopener noreferrer"
              className="rl-btn-ig"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              Follow @carnivalcastle
            </a>
            <a
              href="https://wa.me/918374777834"
              target="_blank"
              rel="noopener noreferrer"
              className="rl-btn-gold"
            >
              🎉 Book Your Celebration
            </a>
          </div>

        </div>
      </section>
    </>
  );
}